<template>
  <div class="order-container">
    <div class="order-content" :style="{'padding-bottom': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
      <slot></slot>
    </div>
    <div class="footer">
      <div class="footer-content">
        <div class="deep-text-color" style="line-height: 34px;">
          <span style="font-weight: normal;">总计:</span>
          <span class="research-font-color bold-text" style="font-size: 18px; margin-right: 5px;">¥{{emkt.formatPrice(totalMoney)}}</span>
        </div>
        <div v-if="showButton" class="pay-btn research-background-color" @click="response">{{buttonName}}</div>
        <div v-else class="pay-btn" style="background-color: gainsboro">{{buttonName}}</div>
      </div>
      <footer-placeholder></footer-placeholder>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
  import emkt from './../../emkt'
  import {mapGetters} from 'vuex'
  import FooterPlaceholder from '../components/FooterPlaceholder'
  export default {
    components: {FooterPlaceholder},
    data () {
      return {
        message: '',
        agree: Boolean
      }
    },
    props: ['buttonName', 'totalMoney', 'showButton'],
    computed: {
      ...mapGetters([
        'isNewCustomerWithoutHistoryOrders'
      ])
    },
    methods: {
      isPreSaleOrder () {
        const preSalePeriod = []
        emkt.christmasPreSalePeriod.forEach((timeString) => {
          preSalePeriod.push(new Date(timeString))
        })
        console.log('presaleperiod', preSalePeriod)
        const now = new Date()
        let isPreSale = false
        if (now > preSalePeriod[0] && now < preSalePeriod[1]) {
          isPreSale = true
          console.log('first day, all orders are pre sale orders')
        } else if ((now > preSalePeriod[2] && now < preSalePeriod[3]) || (now > preSalePeriod[4] && now < preSalePeriod[5])) {
          console.log('second/third day, new customers\' orders are pre sale orders')
          isPreSale = this.isNewCustomerWithoutHistoryOrders
        }
        console.log('is pre sale', isPreSale)
        return isPreSale
      },
      response () {
        const _this = this
        if (this.buttonName === '确认下单') {
          console.log('isNewCustomerWithoutHistoryOrders', this.isNewCustomerWithoutHistoryOrders)
          let preSaleText = ''
          if (this.isPreSaleOrder()) {
            preSaleText = '本产品为预售产品，3月初发货，请知悉! 如有疑问可联系在线客服或业务员！<br>'
          }
          let showText = `<div><span style="color: #ff0000">${preSaleText}</span> 请您仔细核对订单信息（包括物品，发票，发货地址，发货方式和结算方式）
           确认订单后吉凯将尽快对您的订单进行审核，审核通过之前，您仍旧可以在“我的”界面中的“待收货”模块下找到您的订单。</div>`
          this.$weui.dialog({
            content: showText,
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                _this.$emit('response')
              }
            }]
          })
          // $.modal({
          //   text: showText,
          //   buttons: [
          //     {
          //       text: 'Cancel',
          //       onClick: function () {
          //       }
          //     },
          //     {
          //       text: 'OK',
          //       onClick: function () {
          //         $.showIndicator()
          //         setTimeout(function () {
          //           $.hideIndicator()
          //         }, 300)
          //         _this.$emit('response')
          //       }
          //     }
          //   ]
          // })
        } else {
          _this.$emit('response')
        }
      }
    }
  }
</script>

<style scoped>
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: bold;
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }
  .alert-text {
    color: #FE654D;
  }
  .order-container {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100vh;
    position: relative;
    background-color: #FAFAFA;
    padding: 10px;
    padding-bottom: 0;
    font-size: 12px;
  }

  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    background-color: #fff;
    z-index: 10;
  }
  .footer-content {
    height: 55px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 9px 10px;
  }
  .content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    background-color: #fff;
  }
  .default-flag {
    width: 30px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .block-item {
    height: 62px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 85%;
  }
  .text-overflow-hidden {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .price-info {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .pay-btn {
    width: 109px;
    height: 34px;
    border-radius: 17px;
    line-height: 34px;
    color: #fff;
    text-align: center;
  }
  .return-btn {
    width: 110px;
    height: 34px;
    border-radius: 17px;
    line-height: 34px;
    text-align: center;
    background-color: #fff;
    border:1px solid #5878fa;
  }
  .customer-service {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .split-line {
    border-top: .7px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
    background: no-repeat center;
    background-image: url('/static/img/tick.png');
    background-size: .6rem .45rem;
  }

  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
  .background-modal {
    opacity: 0.55;
    background: #000000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
  }
  .choose-balance-account, .choose-pay-method {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 10px;
    z-index: 20;
    font-size: 14px;
    color: #979797;
  }
  .verity-info {
    text-align: left;
    font-size: 14px;
    color: #979797;
    font-weight: normal;
    width: 74%;
    outline: none;
    border: none;
    padding: 0;
  }
  .verify-account {
    background-color: #FAFAFA;
    padding: 10px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    font-size: 14px;
  }
  .remind-info {
    line-height: 20px;
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// OrderContentFramework.vue?54ad9720